export const childusers_config = {
  sample: {
    apiEndpoints: {
      listUsers: '/api/v3/admin/onboarding/child-users/get_childs',
      updatePassword: '/api/v3/admin/onboarding/child-users/update-password',
      unblockUser: '/api/v3/admin/users/unlock_account'
    },
    
    apiConfig: {
      headers: {
        'x-change-case': true
      },
      validateStatus: () => true
    },
    
    tableColumns: ['name', 'primaryPhoneNo', 'email', 'state', 'action'],
    columnConfig: {
      name: {
        width: 150,
        filterable: false,
        sortable: false,
        fields: ['first_name', 'last_name']
      },
      primaryPhoneNo: {
        width: 130,
        filterable: false,
        sortable: false,
        field: 'primary_phone_no'
      },
      email: {
        width: 220,
        filterable: false,
        sortable: false,
        field: 'email'
      },
      state: {
        width: 100,
        filterable: false,
        sortable: false,
        field: 'state'
      },
      action: {
        width: 260,
        filterable: false,
        sortable: false,
        field: 'action',
        type: 'actions'
      }
    },
    pageSize: 20,
    searchable: true,
    searchField: 'email',

    styling: {
      container: { padding: '20px' },
      card: {
        bg: '#fff',
        variant: 's'
      },
      table: {
        className: 'striped responsive',
        size: 'xs',
        showTotalCount: false,
        sortable: true
      },
      modal: {
        padding: 10,
        minWidth: 520
      },
      buttons: {
        updatePassword: {
          variant: 'primary',
          margin: { left: 0 }
        },
        unblockUser: {
          variant: 'primary',
          margin: { left: 3 }
        }
      }
    },

    formConfig: {
      label: 'Update Password',
      formKey: 'updatePassword',
      options: {},
      desc: 'Password Requirements: Minimum 10 characters, at least 2 lowercase letters, 2 uppercase letters, 1 special character (!@#$%^&*), and 1 number',
      styles: {},
      formConfig: {
        '1': {
          data: [
            {
              formKey: 'password',
              validation: 'required',
              label: 'Password',
              type: 'password',
              placeholder: 'Enter Password',
              row: 1,
              styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
              dependency: null,
              options: null
            },
            {
              formKey: 'confirmPassword',
              validation: 'required',
              label: 'Confirm Password',
              type: 'password',
              placeholder: 'Enter Confirm Password',
              row: 1,
              styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
              dependency: null,
              options: null
            }
          ],
          style: {}
        }
      },
      submitConfig: {
        submitButton: {
          label: 'Submit',
          style: {},
          isDisplay: true
        },
        resetButton: {
          isDisplay: true,
          label: 'Reset',
          style: {}
        }
      }
    },
    
    labels: {
      pageTitle: 'Child Users Of Parent',
      headerLabel: 'Child Users',
      name: 'Name',
      primaryPhoneNo: 'Phone No.',
      email: 'Email',
      state: 'State',
      action: 'Action',
      modalTitle: 'Update Password for',
      loadingConfig: 'Loading configuration...'
    },
    
    actions: {
      updatePassword: {
        label: 'Update Password',
        type: 'modal',
        variant: 'primary',
        marginLeft: 0,
        modalConfig: 'updatePassword',
        apiKey: 'updatePassword',
        method: 'PUT',
        payload: {
          password: 'password',
          password_confirmation: 'confirmPassword'
        }
      },
      unblockUser: {
        label: 'Unblock User',
        type: 'api',
        apiKey: 'unblockUser',
        method: 'POST',
        payload: { user_id: 'id' },
        variant: 'primary',
        marginLeft: 3
      }
    }
  }
}
